import { createSelector } from 'reselect';
import { getSelectedLayout } from '../../../utilities/get-selected-layout.esm.js';
import { modifyCurrentLayout } from '../../../utilities/modify-current-layout.esm.js';
import { sameArray } from '../../../utilities/same-array.esm.js';
import { getLockedFields } from '../../../utilities/get-locked-fields.esm.js';
import { createAvailableOptionsStringMapSelector } from './available-options-string-map-selector.esm.js';

var getCurrentFields = function getCurrentFields(idStringMap, layouts) {
  var _getSelectedLayout$fi, _getSelectedLayout$fi2, _getSelectedLayout$fi3;
  return (_getSelectedLayout$fi = getSelectedLayout(layouts).fields) === null || _getSelectedLayout$fi === void 0 ? void 0 : (_getSelectedLayout$fi2 = _getSelectedLayout$fi.map(function (f) {
    return idStringMap.toString(f);
  })) === null || _getSelectedLayout$fi2 === void 0 ? void 0 : (_getSelectedLayout$fi3 = _getSelectedLayout$fi2.filter(function (f) {
    return f !== undefined;
  })) === null || _getSelectedLayout$fi3 === void 0 ? void 0 : _getSelectedLayout$fi3.map(function (f) {
    return f;
  });
};
var sameFields = function sameFields(idStringMap, lockedFields) {
  return function (currentFields, selectedFields) {
    var _lockedFields = lockedFields.map(function (f) {
      return idStringMap.toString(f);
    });
    var _currentFields = currentFields === null || currentFields === void 0 ? void 0 : currentFields.filter(function (f) {
      return !_lockedFields.includes(f);
    });
    var _selectedFields = selectedFields.filter(function (f) {
      return !_lockedFields.includes(f);
    });
    return sameArray(_currentFields, _selectedFields);
  };
};
var getNewTableDefinitionFunction = function getNewTableDefinitionFunction(idStringMap, displayLayouts, resources, lockedFields) {
  return function (selectedFields) {
    var currentFields = getCurrentFields(idStringMap, displayLayouts);
    if (sameFields(idStringMap, lockedFields)(currentFields, selectedFields)) {
      return displayLayouts;
    }
    var fields = selectedFields.map(function (f) {
      return idStringMap.fromString(f);
    }).filter(function (f) {
      return f !== undefined;
    }).map(function (f) {
      return f;
    });
    var layouts = modifyCurrentLayout(resources, lockedFields)(displayLayouts, fields);
    return layouts;
  };
};
function getTransferListCallback(idStringMap, displayLayouts, setDisplayLayouts, resources, allFields) {
  var lockedFields = getLockedFields(allFields);
  var getNewTableDefinition = getNewTableDefinitionFunction(idStringMap, displayLayouts, resources, lockedFields);
  return function (selectedFields) {
    var newDisplayLayouts = getNewTableDefinition(selectedFields);
    if (newDisplayLayouts !== displayLayouts) {
      setDisplayLayouts(newDisplayLayouts);
    }
  };
}
var createTransferListCallbackSelector = function createTransferListCallbackSelector() {
  var availableOptionsStringMapSelector = createAvailableOptionsStringMapSelector();
  return createSelector(availableOptionsStringMapSelector, function (props) {
    return props.displayLayouts;
  }, function (props) {
    return props.setDisplayLayouts;
  }, function (props) {
    return props.resources.layouts;
  }, function (props) {
    return props.allFields;
  }, getTransferListCallback);
};

export { createTransferListCallbackSelector };
//# sourceMappingURL=transfer-list-callback-selector.esm.js.map
